module.exports = __webpack_public_path__ + "img/hr-dirt-6.3a569c14.png";